import { gql } from '@apollo/client';

export const CREATE_REPORT_MUTATION = gql`
  mutation createSmartReport($input: SmartReportCreateInput!) {
    createSmartReport(input: $input) {
      id
      createdAt
      createdBy {
        id
      }
      smartReportEntities {
        entityId
        entityType
        entity {
          id
          name
        }
      }
      smartReportVersions {
        id
        status
        createdAt
      }
    }
  }
`;

export const UPDATE_REPORT_MUTATION = gql`
  mutation updateSmartReport($id: ID!, $input: SmartReportUpdateInput!) {
    updateSmartReport(id: $id, input: $input) {
      id
      name
      description
      updatedAt
    }
  }
`;

export const UPDATE_REPORT_VERSION_MUTATION = gql`
  mutation updateSmartReportVersion($id: ID!, $input: SmartReportVersionUpdateInput!) {
    updateSmartReportVersion(id: $id, input: $input) {
      id
      number
      status
      pages {
        thumbnailUrl
        description
        number
        pageElements {
          componentId
          slotId
          style
          payload
          data
        }
      }
    }
  }
`;

export const PUBLISH_VERSION_MUTATION = gql`
  mutation publishSmartReportVersion($id: ID!) {
    publishSmartReportVersion(id: $id) {
      id
      name
      smartReportVersions {
        id
        status
        publishedAt
      }
    }
  }
`;

export const SMART_REPORTS_QUERY = gql`
  query getSmartReports($search: String, $pagination: PaginationInput) {
    smartReportsList(search: $search, pagination: $pagination) {
      reports {
        id
        name
        description
        status
        smartReportType {
          id
          name
        }
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        smartReportEntities {
          entityId
          entityType
          entity {
            id
            name
          }
        }
        smartReportVersions {
          id
          number
          status
          createdAt
          createdBy {
            id
            firstName
            lastName
          }
          isLatest
          publishedAt
        }
      }
      totalCount
    }
  }
`;

export const GET_REPORT_TYPES_QUERY = gql`
  {
    smartReportTypes {
      id
      name
    }
  }
`;

export const GET_REPORT_TEMPLATES_QUERY = gql`
  {
    smartReportTemplates {
      templates {
        id
        name
        thumbnailUrl
      }
      totalCount
    }
  }
`;

export const GET_REPORT_QUERY = gql`
  query getSmartReport($id: ID!) {
    smartReport(id: $id) {
      id
      name
      description
      status
      smartReportType {
        id
        name
      }
      createdAt
      createdBy {
        id
        firstName
        lastName
      }
      smartReportEntities {
        entityId
        entityType
        entity {
          id
          name
        }
      }
      smartReportVersions {
        id
        number
        status
        createdAt
        createdBy {
          id
          firstName
          lastName
        }
        pages {
          layout
          thumbnailUrl
          description
          number
          pageElements {
            componentId
            slotId
            style
            payload
            data
          }
        }
      }
    }
  }
`;

export const CREATE_VERSION_MUTATION = gql`
  mutation createSmartReportVersion($reportId: ID!) {
    createSmartReportVersion(reportId: $reportId) {
      id
    }
  }
`;
